import actionTypes from 'redux/actions/actionTypes'
import activityTypes from 'helpers/enums/activityTypes'

const defaultState = {
	entities: {},
}

const actionTypeActivityType = {
	[actionTypes.CREATION_TOOL_OEQ_QUESTION_GET_SUCCESS]: activityTypes.OPEN_ENDED_QUESTION,
	[actionTypes.CREATION_TOOL_MCQ_QUESTION_GET_SUCCESS]: activityTypes.MULTIPLE_CHOICE_QUESTION,
}

function addActivity(state, action) {
	return {
		...state,
		entities: {
			...state.entities,
			[action.entity.uid]: {
				type: actionTypeActivityType[action.type],
				entity: action.entity,
			},
		},
	}
}

const activitiesReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.CREATION_TOOL_MCQ_QUESTION_GET_SUCCESS:
		case actionTypes.CREATION_TOOL_OEQ_QUESTION_GET_SUCCESS:
			return addActivity(state, action)
		default:
			return state
	}
}

export default activitiesReducer

export {
	defaultState,
}
